// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/DroidSans-Bold-webfont.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/DroidSans-webfont.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "droid_sansbold";
  src: local("DroidSans-Bold-webfont.ttf"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "droid_sansregular";
  src: local("DroidSans-webfont.ttf"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
*,
*::before,
*::after {
  box-sizing: border-box;
}

* {
  margin: 0;
  padding: 0;
}

ul[role=list],
ol[role=list] {
  list-style: none;
}

html:focus-within {
  scroll-behavior: smooth;
}

a:not([class]) {
  text-decoration-skip-ink: auto;
}

img,
picture,
svg,
video,
canvas {
  max-width: 100%;
  height: auto;
  vertical-align: middle;
  font-style: italic;
  background-repeat: no-repeat;
  background-size: cover;
}

input,
button,
textarea,
select {
  font: inherit;
}

@media (prefers-reduced-motion: reduce) {
  html:focus-within {
    scroll-behavior: auto;
  }
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
    transition: none;
  }
}
body,
html {
  height: 100%;
  scroll-behavior: smooth;
}

.sidebar-container {
  width: calc(100% - 1rem);
  max-width: 90px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #002a79;
  min-height: calc(100vh - 86px);
  margin-right: 1rem;
}

.sidebar-container ul {
  width: 100%;
  display: block;
}

.side-nav {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  width: 100%;
  padding: 0.75rem 0;
}
.side-nav:hover {
  background: #0b5afa;
  background: linear-gradient(0deg, rgb(11, 90, 250) 0%, rgb(53, 113, 249) 100%);
}

.side-nav.active {
  background: #0b5afa;
  background: linear-gradient(0deg, rgb(11, 90, 250) 0%, rgb(53, 113, 249) 100%);
}

.side-nav a {
  border-radius: 50%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #2f2f2f;
}
.side-nav a:nth-child(2) {
  background-color: transparent;
  width: max-content;
  display: flex;
  height: auto;
}

.sidenav-icon {
  font-size: 30px;
  color: #fff;
}

.sidenav-icon.active {
  color: #e56d0d;
}

.sidenav-icon-img {
  width: 30px;
  height: 30px;
  color: #2f2f2f;
}

.icon-active {
  color: #d33f38;
}

.mob-menu {
  display: block;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  font-family: poppins;
}

.side-nav:hover a {
  text-decoration: none;
}

@media (max-width: 767px) {
  .sidebar-container {
    position: absolute;
    width: 100%;
    max-width: 100%;
    left: 0;
    z-index: 3;
    align-items: flex-start;
    padding: 0 1.5rem;
    animation: sideNavMove 0.5s ease-in-out forwards;
  }
  @keyframes sideNavMove {
    0% {
      top: -100%;
    }
    100% {
      top: 150px;
    }
  }
  .sidebar-container ul {
    width: 100%;
  }
  .mob-menu {
    font-size: 16px;
    text-transform: uppercase;
    color: #fff;
    line-height: 1;
    display: flex;
    white-space: nowrap;
  }
  .side-nav {
    column-gap: 1rem;
    flex-direction: row;
    justify-content: flex-start;
  }
  .side-nav a {
    flex-direction: row;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/mixins/fonts.scss","webpack://./src/components/sidebar/SideBar.scss","webpack://./src/assets/mixins/reset.scss","webpack://./src/assets/mixins/colors.scss"],"names":[],"mappings":"AAEA;EACE,6BAAA;EACA,oGAAA;EAEA,mBAAA;EACA,kBAAA;ACAF;ADEA;EACE,gCAAA;EACA,+FAAA;EAEA,mBAAA;EACA,kBAAA;ACDF;ACbA;;;EAGE,sBAAA;ADeF;;ACZA;EACE,SAAA;EACA,UAAA;ADeF;;ACZA;;EAEE,gBAAA;ADeF;;ACZA;EACE,uBAAA;ADeF;;ACZA;EACE,8BAAA;ADeF;;ACZA;;;;;EAKE,eAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,4BAAA;EACA,sBAAA;ADeF;;ACZA;;;;EAIE,aAAA;ADeF;;ACZA;EACE;IACE,qBAAA;EDeF;ECbA;;;IAGE,qCAAA;IACA,uCAAA;IACA,sCAAA;IACA,gCAAA;IACA,gBAAA;EDeF;AACF;ACZA;;EAEE,YAAA;EACA,uBAAA;ADcF;;AA3EA;EACE,wBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;EACA,kBAAA;AA8EF;;AA5EA;EACE,WAAA;EACA,cAAA;AA+EF;;AA7EA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EAEA,WAAA;EACA,kBAAA;AA+EF;AA1EA;EACE,mBAAA;EACA,8EAAA;AA4EF;;AAtEA;EACE,mBAAA;EACA,8EAAA;AAyEF;;AAnEA;EAEE,kBAAA;EACA,WAAA;EAEA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cEjDW;AFqHb;AAnEE;EACE,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;AAqEJ;;AAlEA;EACE,eAAA;EACA,WE5DM;AFiIR;;AAnEA;EACE,cAAA;AAsEF;;AApEA;EACE,WAAA;EACA,YAAA;EACA,cEnEW;AF0Ib;;AApEA;EACE,cAAA;AAuEF;;AArEA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AAwEF;;AArEA;EACE,qBAAA;AAwEF;;AAtEA;EACE;IACE,kBAAA;IACA,WAAA;IACA,eAAA;IACA,OAAA;IACA,UAAA;IACA,uBAAA;IACA,iBAAA;IACA,gDAAA;EAyEF;EAvEA;IACE;MACE,UAAA;IAyEF;IAvEA;MACE,UAAA;IAyEF;EACF;EAvEA;IACE,WAAA;EAyEF;EAvEA;IACE,eAAA;IACA,yBAAA;IACA,WE9GI;IF+GJ,cAAA;IACA,aAAA;IACA,mBAAA;EAyEF;EAvEA;IACE,gBAAA;IACA,mBAAA;IACA,2BAAA;EAyEF;EAvEA;IACE,mBAAA;EAyEF;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap\");\r\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\r\n@font-face {\r\n  font-family: \"droid_sansbold\";\r\n  src: local(\"DroidSans-Bold-webfont.ttf\"),\r\n    url(\"../../assets/fonts/DroidSans-Bold-webfont.ttf\") format(\"truetype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n@font-face {\r\n  font-family: \"droid_sansregular\";\r\n  src: local(\"DroidSans-webfont.ttf\"),\r\n    url(\"../../assets/fonts/DroidSans-webfont.ttf\") format(\"truetype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n@mixin primeFont() {\r\n  font-family: \"Abril Fatface\", serif;\r\n  font-weight: 400;\r\n  font-style: normal;\r\n}\r\n@mixin secondaryFont() {\r\n  font-family: \"Poppins\", sans-serif;\r\n  font-optical-sizing: auto;\r\n  font-weight: 400;\r\n  font-style: normal;\r\n}\r\n@mixin secondaryFontBold() {\r\n  font-family: \"Poppins\", sans-serif;\r\n  font-optical-sizing: auto;\r\n  font-weight: 500;\r\n  font-style: normal;\r\n}\r\n","@import url(\"https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@font-face {\n  font-family: \"droid_sansbold\";\n  src: local(\"DroidSans-Bold-webfont.ttf\"), url(\"../../assets/fonts/DroidSans-Bold-webfont.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"droid_sansregular\";\n  src: local(\"DroidSans-webfont.ttf\"), url(\"../../assets/fonts/DroidSans-webfont.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n}\n\nul[role=list],\nol[role=list] {\n  list-style: none;\n}\n\nhtml:focus-within {\n  scroll-behavior: smooth;\n}\n\na:not([class]) {\n  text-decoration-skip-ink: auto;\n}\n\nimg,\npicture,\nsvg,\nvideo,\ncanvas {\n  max-width: 100%;\n  height: auto;\n  vertical-align: middle;\n  font-style: italic;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  html:focus-within {\n    scroll-behavior: auto;\n  }\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n    transition: none;\n  }\n}\nbody,\nhtml {\n  height: 100%;\n  scroll-behavior: smooth;\n}\n\n.sidebar-container {\n  width: calc(100% - 1rem);\n  max-width: 90px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: #002a79;\n  min-height: calc(100vh - 86px);\n  margin-right: 1rem;\n}\n\n.sidebar-container ul {\n  width: 100%;\n  display: block;\n}\n\n.side-nav {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n  width: 100%;\n  padding: 0.75rem 0;\n}\n.side-nav:hover {\n  background: #0b5afa;\n  background: linear-gradient(0deg, rgb(11, 90, 250) 0%, rgb(53, 113, 249) 100%);\n}\n\n.side-nav.active {\n  background: #0b5afa;\n  background: linear-gradient(0deg, rgb(11, 90, 250) 0%, rgb(53, 113, 249) 100%);\n}\n\n.side-nav a {\n  border-radius: 50%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  color: #2f2f2f;\n}\n.side-nav a:nth-child(2) {\n  background-color: transparent;\n  width: max-content;\n  display: flex;\n  height: auto;\n}\n\n.sidenav-icon {\n  font-size: 30px;\n  color: #fff;\n}\n\n.sidenav-icon.active {\n  color: #e56d0d;\n}\n\n.sidenav-icon-img {\n  width: 30px;\n  height: 30px;\n  color: #2f2f2f;\n}\n\n.icon-active {\n  color: #d33f38;\n}\n\n.mob-menu {\n  display: block;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n  font-family: poppins;\n}\n\n.side-nav:hover a {\n  text-decoration: none;\n}\n\n@media (max-width: 767px) {\n  .sidebar-container {\n    position: absolute;\n    width: 100%;\n    max-width: 100%;\n    left: 0;\n    z-index: 3;\n    align-items: flex-start;\n    padding: 0 1.5rem;\n    animation: sideNavMove 0.5s ease-in-out forwards;\n  }\n  @keyframes sideNavMove {\n    0% {\n      top: -100%;\n    }\n    100% {\n      top: 150px;\n    }\n  }\n  .sidebar-container ul {\n    width: 100%;\n  }\n  .mob-menu {\n    font-size: 16px;\n    text-transform: uppercase;\n    color: #fff;\n    line-height: 1;\n    display: flex;\n    white-space: nowrap;\n  }\n  .side-nav {\n    column-gap: 1rem;\n    flex-direction: row;\n    justify-content: flex-start;\n  }\n  .side-nav a {\n    flex-direction: row;\n  }\n}","*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nul[role=\"list\"],\r\nol[role=\"list\"] {\r\n  list-style: none;\r\n}\r\n\r\nhtml:focus-within {\r\n  scroll-behavior: smooth;\r\n}\r\n\r\na:not([class]) {\r\n  text-decoration-skip-ink: auto;\r\n}\r\n\r\nimg,\r\npicture,\r\nsvg,\r\nvideo,\r\ncanvas {\r\n  max-width: 100%;\r\n  height: auto;\r\n  vertical-align: middle;\r\n  font-style: italic;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n}\r\n\r\ninput,\r\nbutton,\r\ntextarea,\r\nselect {\r\n  font: inherit;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  html:focus-within {\r\n    scroll-behavior: auto;\r\n  }\r\n  *,\r\n  *::before,\r\n  *::after {\r\n    animation-duration: 0.01ms !important;\r\n    animation-iteration-count: 1 !important;\r\n    transition-duration: 0.01ms !important;\r\n    scroll-behavior: auto !important;\r\n    transition: none;\r\n  }\r\n}\r\n\r\nbody,\r\nhtml {\r\n  height: 100%;\r\n  scroll-behavior: smooth;\r\n}\r\n","$primary-color: #0d47a0;\r\n$primary-color-hover: #093373;\r\n$secondary-blue: #93cfff;\r\n$background-color: #f4f6fa;\r\n$white: #fff;\r\n$text-color: #2f2f2f;\r\n$text-dark-color: #072148;\r\n$table-stroke-color: #dfdfdf;\r\n$stroke-color: #949494;\r\n$input-stroke: #e4e8e9;\r\n$text-warning: #ed8b00;\r\n$text-danger: #cc3201;\r\n$text-success: #339900;\r\n$tooltip-bg: #0d47a0;\r\n$tooltip-color: #ffffff;\r\n$button-color: #ff6b00;\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
